import { render, staticRenderFns } from "./HierarchicalRatingsTable.vue?vue&type=template&id=12198a17&scoped=true"
import script from "./HierarchicalRatingsTable.vue?vue&type=script&lang=js"
export * from "./HierarchicalRatingsTable.vue?vue&type=script&lang=js"
import style0 from "./HierarchicalRatingsTable.vue?vue&type=style&index=0&id=12198a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12198a17",
  null
  
)

export default component.exports